import { render, staticRenderFns } from "./ProductionAdjustment.vue?vue&type=template&id=082a7b5e&scoped=true&"
import script from "./ProductionAdjustment.vue?vue&type=script&lang=js&"
export * from "./ProductionAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a7b5e",
  null
  
)

export default component.exports